// The link a player should load for a list/search item.
// Since 2026-10-25 the public lists send no original link (url '') for a video that has
// playback copies — originals are staff-only. So: the requested size if that copy
// exists, else the NEAREST copy (cards stay light, full screen stays sharp), else the
// original (photos, videos with no copies, staff rows). Never fall back to `url` while
// a copy exists — that is now an empty string for most visitors.
const CARD_SIZE = 480;

export function playableUrl(item, preferredQuality) {
  const copies = Array.isArray(item?.qualityTypeArray) ? item.qualityTypeArray.filter((q) => q?.qualityvideoname) : [];
  if (copies.length === 0) return item?.url || '';
  const exact = copies.find((q) => String(q.qualitytype) === String(preferredQuality));
  if (exact) return exact.qualityvideoname;
  const target = parseInt(preferredQuality, 10) || CARD_SIZE;
  const nearest = copies.reduce((best, q) => {
    const d = Math.abs((parseInt(q.qualitytype, 10) || 0) - target);
    return !best || d < best.d ? { q, d } : best;
  }, null);
  return nearest.q.qualityvideoname;
}
